export default __webpack_public_path__ + "static/media/Type D main cover.6d597888.png";